// Debugging confirmation
console.log('✅ Home Page Builder loaded successfully!');

// Home Page Builder
export async function buildContentHomePage() {
  console.log(`🏗️ Home Page Builder - Starting Building Home Page`);

  try {
    // 1. Kick off *all* dynamic imports at once, including your component
    const [
      { buildMasterPageByMasterLayoutBuildManager },
      { getRegularPageLayoutContentByFolderPath },
      { buildPageSEOTagsAsync },
    ] = await Promise.all([
      import(
        /* webpackChunkName:"build-manager-master-pages", webpackPrefetch: true   */ '../js/build-manager-master-pages.js'
      ),
      import(
        /* webpackChunkName:"build-manager-utils", webpackPrefetch: true   */ '../js/build-manager-utils.js'
      ),
      import(/* webpackChunkName:"seo-tags", webpackPrefetch: true   */ '../js/utils-seo.js'),
    ]);

    // Build core layout first
    const [masterLayout, pageLayout, pageHeaderTags] = await Promise.all([
      buildMasterPageByMasterLayoutBuildManager('master-layout-shop'),
      getRegularPageLayoutContentByFolderPath('pages/home'),
      buildPageSEOTagsAsync('keyHome'),
    ]);

    //  // Dynamically import and alias named exports in parallel
    const [
      { buildComponentHomePageTopCarouselWideGrey },
      { buildComponentHomePageTrendingListings },
      { buildComponentHomePageFeaturedCategories },
      { buildComponentHomePageMiddleSection },
      { buildComponentHomePageFeaturedListings },
      { buildComponentHomePageFeaturedProducts },
      { buildComponentHomePageRequestQuote },
    ] = await Promise.all([
      import(
        /* webpackChunkName: "home-top-carousel", webpackPrefetch: true   */
        '../builders-components/carousels/home-page-top-carousel-wide-grey.js'
      ),
      import(
        /* webpackChunkName: "home-trending-listings", webpackPrefetch: true   */
        '../builders-components/home/home-page-trending-listings.js'
      ),
      import(
        /* webpackChunkName: "home-featured-categories", webpackPrefetch: true   */
        '../builders-components/home/home-page-featured-categories.js'
      ),
      import(
        /* webpackChunkName: "home-middle-section", webpackPrefetch: true   */
        '../builders-components/home/home-page-middle-section.js'
      ),
      import(
        /* webpackChunkName: "home-featured-listings", webpackPrefetch: true   */
        '../builders-components/home/home-page-featured-listings.js'
      ),
      import(
        /* webpackChunkName: "home-featured-products", webpackPrefetch: true   */
        '../builders-components/home/home-page-featured-products.js'
      ),
      import(
        /* webpackChunkName: "home-request-quote", webpackPrefetch: true   */
        '../builders-components/home/home-page-request-quote.js'
      ),
    ]);

    // Plug components into the page layout

    //let content = "";
    let content = pageLayout
      .replace(
        '{{{ home-page-top-carousel-wide-grey }}}',
        await buildComponentHomePageTopCarouselWideGrey()
      )
      .replace(
        '{{{ home-page-trending-listings }}}',
        await buildComponentHomePageTrendingListings()
      )
      .replace(
        '{{{ home-page-featured-categories }}}',
        await buildComponentHomePageFeaturedCategories()
      )
      .replace('{{{ home-page-middle-section }}}', await buildComponentHomePageMiddleSection())
      .replace(
        '{{{ home-page-featured-listings }}}',
        await buildComponentHomePageFeaturedListings()
      )
      .replace(
        '{{{ home-page-featured-products }}}',
        await buildComponentHomePageFeaturedProducts()
      )
      .replace('{{{ home-page-request-quote }}}', await buildComponentHomePageRequestQuote());

    const [{ isNodeEnvironment }] = await Promise.all([
      import(
        /* webpackChunkName: "utils-fetch-data-json" */
        '../js/utils-fetch-data-json.js'
      ),
    ]);

    let masterPageName = 'master-layout-shop';
    let masterLayoutX = `<div id="x-my-page-layout">${masterLayout}</div>`;

    //wrap page content into container
    let pageContentX = `<div id="x-my-page-content">${content}</div>`;

      if (isNodeEnvironment()) {

          // replace <link rel="canonical" href="https://towobo.com"> with <link rel="canonical" href="https://towobo.com">
          //<link rel="alternate" hreflang="x-default" href="https://towobo.com"> with <link rel="alternate" hreflang="x-default" href="https://towobo.com">

      }


    console.log(`🔄 buildContentHomePage Builder - End Building buildContentHomePage`);
    return {
      masterPageName: 'master-layout-shop',
      masterPageHtml: masterLayoutX,
      pageContentHtml: pageContentX,
      pageHeaderTags: pageHeaderTags,
    };



  } catch (error) {
    console.error('❌ Error building home page content:', error);
    return 'Error loading home page content.', error;
  }
}

